import AppointChart from "./AppointChart";
import AppointmentFunnel from "./AppointmentFunnel";
import AppointType from "./AppointType";
import FacilityUtilization from "./FacilityUtilization";
import TimeSlotHeatmap from "./TimeSlotHeatmap";



function App() {
  return (
    <div className="App">
      <div style={{ padding: '30px', background: '#f8f9fb' }}>
        <AppointChart />
        <AppointType />
        <TimeSlotHeatmap />
        <AppointmentFunnel />
        <div
          style={{
            flex: 1,
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            padding: "24px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
            border: "1px solid #e5e7eb",
          }}
        >
          <FacilityUtilization />
        </div>
      </div>
    </div>
  );
}

export default App;
